const rankings = [
  {
    rank: 1,
    title: '顶流男星深夜发文暗示恋情，粉丝集体炸锅',
    heat: '128万',
    trend: 'hot',
    tag: '娱乐圈',
  },
  {
    rank: 2,
    title: '年度热播古装剧大结局口碑逆袭，全员演技在线',
    heat: '115万',
    trend: 'up',
    tag: '影视剧',
  },
  {
    rank: 3,
    title: '知名网红偷税漏税被查，账号已被平台封禁',
    heat: '102万',
    trend: 'hot',
    tag: '网红圈',
  },
  {
    rank: 4,
    title: '体育圈重磅消息：CBA巨星或将转投海外联赛',
    heat: '89万',
    trend: 'up',
    tag: '体育圈',
  },
  {
    rank: 5,
    title: '互联网两大巨头官司尘埃落定，行业格局生变',
    heat: '76万',
    trend: 'stable',
    tag: '科技圈',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-foreground-600 text-sm md:text-base">实时热度排行，看看大家都在关注什么</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 bg-background-50 border border-background-200/60 rounded-xl mb-3 last:mb-0 hover:border-primary-200/50 transition-colors duration-200 cursor-pointer group"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {item.trend === 'hot' && (
                  <span className="flex items-center gap-0.5 text-xs text-primary-600">
                    <i className="ri-fire-line"></i>
                  </span>
                )}
                {item.trend === 'up' && (
                  <span className="flex items-center gap-0.5 text-xs text-accent-600">
                    <i className="ri-arrow-up-line"></i>
                  </span>
                )}
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}